import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import './index.css';
import VideoArenaApp from './VideoArenaApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <GoogleOAuthProvider clientId="340913951280-k4515n3s33o7u8mlucte4t175ufnn10n.apps.googleusercontent.com">
        <VideoArenaApp />
    </GoogleOAuthProvider>
);
